import React, { useState } from "react";
import "./CreateCustomMessage.css";
import { Button, FormControl, TextField, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import { createCustomMessages } from "../../redux/actions";
import Locale from "../../locales";

const useStyles = makeStyles({
  selectRangeContainer: {
    width: "45%",
  },
  message: {
    width: "100%",
  },
  mobileSelectRangeContainer: {
    width: "100%",
  },
});

const CreateCustomMessage = () => {
  const loading = useSelector((state) => state.adminReducer.loading);
  const dispatch = useDispatch();
  const styles = useStyles();
  const [fromRange, setFromRange] = useState("");
  const [toRange, setToRange] = useState("");
  const [message, setMessage] = useState("");
  const isSmall = useMediaQuery("(max-width:1400px)");

  const handleFromRangeChange = (event) => {
    if (event.target.value.length > 2) {
      return;
    }
    setFromRange(event.target.value);
  };

  const handleToRangeChange = (event) => {
    if (event.target.value.length > 3) {
      return;
    }
    setToRange(event.target.value);
  };

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const handleFormSubmit = (event) => {
    if (parseInt(fromRange, 10) > parseInt(toRange, 10)) {
      return;
    }
    event.preventDefault();
    dispatch(
      createCustomMessages(
        parseInt(fromRange, 10),
        parseInt(toRange, 10),
        message,
      ),
    );
  };

  return (
    <div className="create-message-container">
      <div>
        <h1 className="create-message-headingText">
          {Locale.t("create_custom_message")}
        </h1>
      </div>
      <form onSubmit={handleFormSubmit} className="message-form">
        <div className="form-content-container">
          <FormControl
            className={
              isSmall
                ? styles.mobileSelectRangeContainer
                : styles.selectRangeContainer
            }>
            <TextField
              required
              sx={{ marginBottom: "10px" }}
              type="number"
              InputProps={{ inputProps: { min: 0, max: 99 } }}
              id="simple-select"
              value={fromRange}
              label={Locale.t("starting_percentage")}
              onChange={handleFromRangeChange}
            />
          </FormControl>
          <FormControl className={isSmall ? "" : styles.selectRangeContainer}>
            <TextField
              className={isSmall ? styles.mobileSelectRangeContainer : ""}
              required
              type="number"
              id="simple-select"
              InputProps={{ inputProps: { min: +fromRange, max: 100 } }}
              value={toRange}
              label={Locale.t("ending_percentage")}
              onChange={handleToRangeChange}
            />
          </FormControl>
        </div>
        <div className="form-content-container">
          <FormControl className={styles.message}>
            <TextField
              multiline
              minRows={5}
              value={message}
              onChange={handleMessageChange}
              label={Locale.t("Message")}
              required
            />
          </FormControl>
        </div>
        <div className="message-submit-button-container">
          <Button
            disabled={loading}
            style={{ margin: "auto" }}
            type="submit"
            size="large"
            variant="contained">
            {Locale.t("create_message")}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CreateCustomMessage;
